var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ChipButtons',_vm._l((_vm.contentTypes),function(contentType){return _c('ChipButton',{key:contentType.key,attrs:{"active":contentType.isActive}},[_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.toggle(contentType.value)}}},[_vm._v(_vm._s(contentType.translation))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }